var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTuneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tune-icon-specs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tune-icon-base",
    transform: "translate(-165.000000, -446.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.000000, 446.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,16.4444444 L4,18.2222222 L9.33333333,18.2222222 L9.33333333,16.4444444 L4,16.4444444 Z M4,5.77777778 L4,7.55555556 L12.8888889,7.55555556 L12.8888889,5.77777778 L4,5.77777778 Z M12.8888889,20 L12.8888889,18.2222222 L20,18.2222222 L20,16.4444444 L12.8888889,16.4444444 L12.8888889,14.6666667 L11.1111111,14.6666667 L11.1111111,20 L12.8888889,20 Z M7.55555556,9.33333333 L7.55555556,11.1111111 L4,11.1111111 L4,12.8888889 L7.55555556,12.8888889 L7.55555556,14.6666667 L9.33333333,14.6666667 L9.33333333,9.33333333 L7.55555556,9.33333333 Z M20,12.8888889 L20,11.1111111 L11.1111111,11.1111111 L11.1111111,12.8888889 L20,12.8888889 Z M14.6666667,9.33333333 L16.4444444,9.33333333 L16.4444444,7.55555556 L20,7.55555556 L20,5.77777778 L16.4444444,5.77777778 L16.4444444,4 L14.6666667,4 L14.6666667,9.33333333 Z",
    id: "Shape",
    fill: "#515D75",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuneIcon);
export default __webpack_public_path__ + "static/media/tune-icon.f565f776.svg";
export { ForwardRef as ReactComponent };